import { Col, Row, Text } from 'components';
import { useEffect } from 'react';
import { ValueInput } from 'screens/Admin/components';

const Score = ({ data, score, setScore, canUpdateScore }) => {
  useEffect(() => {
    setScore(data.score || { home: null, away: null });
  }, []);

  function handleScore(val, type) {
    const reg = /^\d+$/;
    if (val !== '' && !reg.test(val)) return;
    const newScore = { ...score, [type]: val };
    setScore(newScore);
  }

  if (!canUpdateScore) return null;

  return (
    <Col noFlex wid="100%">
      <Text b2 med marg="0 16px 4px">
        Score
      </Text>

      <Row>
        <Row centerAll>
          <Text marg="0 15px 0 0" wid="150px" right>
            {data.homeName}
          </Text>

          <ValueInput
            wid="40px"
            placeholder="#"
            value={score?.home}
            center
            onChange={({ target }) => handleScore(target.value, 'home')}
          />
        </Row>

        <Col centerAll noFlex ht="100%" wid="50px">
          <Row bg="#000" wid="20px" ht="5px" hasRadius="2px" />
        </Col>

        <Row centerAll>
          <ValueInput
            wid="40px"
            placeholder="#"
            value={score?.away}
            center
            onChange={({ target }) => handleScore(target.value, 'away')}
          />

          <Text marg="0 0 0 15px" wid="150px">
            {data.awayName}
          </Text>
        </Row>
      </Row>
    </Col>
  );
};

export default Score;
